var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { Form, Input, Select, DatePicker, Row, Col, InputNumber, Switch, } from "antd";
var RangePicker = DatePicker.RangePicker;
var Option = Select.Option;
/**
 * 通用搜索组件（内核）
 * 只包含搜索表单核心功能，不包含容器
 */
var CompsSearch = function (_a) {
    var _b = _a.searchItems, searchItems = _b === void 0 ? [] : _b, _c = _a.columns, columns = _c === void 0 ? 3 : _c, onSearch = _a.onSearch, onReset = _a.onReset, _d = _a.collapsible, collapsible = _d === void 0 ? true : _d, _e = _a.defaultCollapsed, defaultCollapsed = _e === void 0 ? false : _e, externalCollapsed = _a.collapsed, onCollapsedChange = _a.onCollapsedChange, _f = _a.labelWidth, labelWidth = _f === void 0 ? 100 : _f, className = _a.className, style = _a.style, _g = _a.showButtons, showButtons = _g === void 0 ? true : _g, _h = _a.buttonPosition, buttonPosition = _h === void 0 ? "right" : _h, customButtons = _a.customButtons, formRef = _a.formRef, onButtonsRender = _a.onButtonsRender, onValuesChange = _a.onValuesChange;
    var form = Form.useForm()[0];
    var _j = useState(defaultCollapsed), internalCollapsed = _j[0], setInternalCollapsed = _j[1];
    // 使用外部控制的 collapsed 或内部状态
    var collapsed = externalCollapsed !== undefined ? externalCollapsed : internalCollapsed;
    // 切换折叠状态（保留用于向后兼容，当 showButtons=true 时可能使用）
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var toggleCollapse = function () {
        var newCollapsed = !collapsed;
        if (onCollapsedChange) {
            onCollapsedChange(newCollapsed);
        }
        else {
            setInternalCollapsed(newCollapsed);
        }
    };
    // 将表单实例传递给父组件
    React.useEffect(function () {
        if (formRef && form) {
            formRef(form);
        }
    }, [form, formRef]);
    // 处理搜索（保留用于向后兼容，当 showButtons=true 时可能使用）
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var handleSearch = function () {
        console.log("[CompsSearch] 搜索按钮被点击");
        form
            .validateFields()
            .then(function (values) {
            console.log("[CompsSearch] 表单验证成功，搜索值:", values);
            onSearch(values);
        })
            .catch(function (errorInfo) {
            console.log("[CompsSearch] 表单验证失败:", errorInfo);
            // 即使验证失败，也执行搜索（使用当前表单值）
            var currentValues = form.getFieldsValue();
            console.log("[CompsSearch] 使用当前表单值进行搜索:", currentValues);
            onSearch(currentValues);
        });
    };
    // 重置表单（保留用于向后兼容，当 showButtons=true 时可能使用）
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var handleReset = function () {
        console.log("[CompsSearch] 重置按钮被点击");
        form.resetFields();
        console.log("[CompsSearch] 表单已重置");
        // 如果有onReset回调，优先调用onReset，否则执行空搜索
        if (onReset) {
            console.log("[CompsSearch] 调用onReset回调");
            onReset();
        }
        else {
            console.log("[CompsSearch] 执行空搜索");
            onSearch({});
        }
    };
    // 计算每个表单项占用的列数
    var getColSpan = function (item) {
        if (item.colSpan)
            return item.colSpan;
        return 24 / columns;
    };
    // 根据折叠状态确定显示的项目
    var visibleItems = collapsed && collapsible ? searchItems.slice(0, columns) : searchItems;
    // 渲染搜索控件（默认 width:100% 充满列宽）
    var renderFormItem = function (item) {
        var type = item.type, options = item.options, _a = item.props, props = _a === void 0 ? {} : _a, customComponent = item.customComponent;
        var style = __assign({ width: "100%" }, props.style);
        switch (type) {
            case "input":
                return _jsx(Input, __assign({ allowClear: true, style: style }, props));
            case "select":
                return (_jsx(Select, __assign({ allowClear: true, style: style }, props, { children: options === null || options === void 0 ? void 0 : options.map(function (opt) { return (_jsx(Option, __assign({ value: opt.value, label: opt.label }, { children: opt.label }), String(opt.value))); }) })));
            case "date":
                return _jsx(DatePicker, __assign({ style: style }, props));
            case "dateRange":
                // RangePicker 支持 picker 属性来切换选择器类型
                // picker="date" - 日期选择器
                // picker="month" - 月份选择器
                // picker="year" - 年份选择器
                return _jsx(RangePicker, __assign({ style: style }, props));
            case "number":
                return _jsx(Input, __assign({ type: "number", allowClear: true, style: style }, props));
            case "inputNumber":
                return _jsx(InputNumber, __assign({ style: style }, props));
            case "switch":
                return _jsx(Switch, __assign({}, props));
            case "custom":
                if (customComponent) {
                    var CustomComponent = customComponent;
                    return _jsx(CustomComponent, __assign({ style: style }, props));
                }
                return _jsx(Input, __assign({ allowClear: true, style: style }, props));
            default:
                return _jsx(Input, __assign({ allowClear: true, style: style }, props));
        }
    };
    // 计算标签宽度的样式
    var labelColStyle = {
        width: typeof labelWidth === "number" ? "".concat(labelWidth, "px") : labelWidth,
        textAlign: "right",
    };
    // 构建容器样式
    var containerStyle = __assign({}, style);
    return (_jsxs("div", __assign({ className: className, style: containerStyle }, { children: [_jsx(Form, __assign({ form: form, layout: "horizontal", onValuesChange: onValuesChange }, { children: _jsx(Row, __assign({ gutter: [16, 16] }, { children: visibleItems.map(function (item) {
                        var _a;
                        // 如果字段有 dependencies，需要使用 Form.Item 的 shouldUpdate 来动态更新
                        if (item.dependencies && item.dependencies.length > 0) {
                            return (_jsx(Col, __assign({ span: getColSpan(item) }, { children: _jsx(Form.Item, __assign({ noStyle: true, shouldUpdate: function (prevValues, currentValues) {
                                        var _a;
                                        // 检查依赖字段是否有变化
                                        return (((_a = item.dependencies) === null || _a === void 0 ? void 0 : _a.some(function (dep) {
                                            return prevValues[dep] !== currentValues[dep];
                                        })) || false);
                                    } }, { children: function (_a) {
                                        var getFieldValue = _a.getFieldValue, getFieldsValue = _a.getFieldsValue;
                                        // 根据依赖字段的值动态设置 disabled
                                        var disabled = false;
                                        if (typeof item.disabled === "function") {
                                            // 使用 getFieldsValue 获取所有表单值，确保获取到最新值
                                            var formValues = getFieldsValue();
                                            disabled = item.disabled(formValues);
                                            // 调试日志（仅在开发环境）
                                            if (process.env.NODE_ENV === "development" &&
                                                item.name === "dateRange") {
                                                console.log("[CompsSearch] ".concat(item.name, " disabled\u72B6\u6001:"), disabled, "dateType:", formValues.dateType);
                                            }
                                        }
                                        else if (typeof item.disabled === "boolean") {
                                            disabled = item.disabled;
                                        }
                                        // 收集依赖字段的值
                                        var dependencyValues = {};
                                        if (item.dependencies && item.dependencies.length > 0) {
                                            item.dependencies.forEach(function (dep) {
                                                dependencyValues[dep] = getFieldValue(dep);
                                            });
                                        }
                                        // 根据 dateType 动态设置 picker 模式（仅对 dateRange 类型）
                                        var finalProps = __assign(__assign({}, item.props), { disabled: disabled });
                                        if (item.type === "dateRange" &&
                                            dependencyValues.dateType !== undefined) {
                                            var dateType = dependencyValues.dateType;
                                            // 根据统计维度设置不同的 picker 模式
                                            if (dateType === 0) {
                                                // 按日统计：使用日期选择器
                                                finalProps.picker = "date";
                                                finalProps.format = "YYYY-MM-DD";
                                            }
                                            else if (dateType === 1) {
                                                // 按月统计：使用月份选择器
                                                finalProps.picker = "month";
                                                finalProps.format = "YYYY-MM";
                                            }
                                            else if (dateType === 2) {
                                                // 按年统计：使用年份选择器
                                                finalProps.picker = "year";
                                                finalProps.format = "YYYY";
                                            }
                                        }
                                        var itemWithDisabled = __assign(__assign({}, item), { props: __assign(__assign({}, finalProps), (item.type === "custom" ? dependencyValues : {})) });
                                        return (_jsx(Form.Item, __assign({ name: item.name, label: _jsx("span", __assign({ style: { color: "#1f1f1f" } }, { children: item.label })), style: { marginBottom: 0 }, labelCol: { style: labelColStyle }, dependencies: item.dependencies, valuePropName: item.type === "switch" ? "checked" : "value" }, { children: renderFormItem(itemWithDisabled) })));
                                    } })) }), item.name));
                        }
                        // 处理普通表单项
                        var disabled = false;
                        if (typeof item.disabled === "function") {
                            var formValues = form.getFieldsValue();
                            disabled = item.disabled(formValues);
                        }
                        else if (typeof item.disabled === "boolean") {
                            disabled = item.disabled;
                        }
                        // 对于 dateRange 类型，如果配置了 dependencies，需要从表单获取 dateType
                        var finalProps = __assign(__assign({}, item.props), { disabled: disabled });
                        if (item.type === "dateRange" &&
                            ((_a = item.dependencies) === null || _a === void 0 ? void 0 : _a.includes("dateType"))) {
                            var formValues = form.getFieldsValue();
                            var dateType = formValues.dateType;
                            if (dateType !== undefined) {
                                // 根据统计维度设置不同的 picker 模式
                                if (dateType === 0) {
                                    // 按日统计：使用日期选择器
                                    finalProps.picker = "date";
                                    finalProps.format = "YYYY-MM-DD";
                                }
                                else if (dateType === 1) {
                                    // 按月统计：使用月份选择器
                                    finalProps.picker = "month";
                                    finalProps.format = "YYYY-MM";
                                }
                                else if (dateType === 2) {
                                    // 按年统计：使用年份选择器
                                    finalProps.picker = "year";
                                    finalProps.format = "YYYY";
                                }
                            }
                        }
                        var itemWithDisabled = __assign(__assign({}, item), { props: finalProps });
                        return (_jsx(Col, __assign({ span: getColSpan(item) }, { children: _jsx(Form.Item, __assign({ name: item.name, label: _jsx("span", __assign({ style: { color: "#1f1f1f" } }, { children: item.label })), style: { marginBottom: 0 }, labelCol: { style: labelColStyle }, dependencies: item.dependencies, valuePropName: item.type === "switch" ? "checked" : "value" }, { children: renderFormItem(itemWithDisabled) })) }), item.name));
                    }) })) })), showButtons && buttonPosition !== "header" && customButtons && (_jsx("div", __assign({ style: {
                    display: "flex",
                    justifyContent: buttonPosition === "left" ? "flex-start" : "flex-end",
                    marginTop: 16,
                } }, { children: customButtons })))] })));
};
export default CompsSearch;
